import { CallBackProps } from 'react-joyride'
import { GuideTypeEnum, IGuide } from 'shared/models/Guide'
import {
  BOARD_AND_COMMITTES_GUIDE_ID,
  EMAIL_COMMON_GUIDE_ID,
  INSURANCE_LIST_GUIDE_ID,
  INVOICE_ALL_INFO_GUIDE_ID,
  INVOICE_ARCHIVE_GUIDE_ID,
  INVOICE_LIST_APPROVE_GUIDE_ID,
  INVOICE_LIST_GUIDE_ID,
  INVOICE_PREVIOUS_GUIDE_ID,
  INVOICE_SUPPLIER_INFO_GUIDE_ID,
  INVOICE_VIEW_ATTACHMENT_GUIDE_ID,
  SKIP_ALL_GUIDES,
  SUBLEASE_HISTORY_GUIDE_ID,
  SUBLEASE_LIST_GUIDE_ID,
  SUBLEASE_OVERRIDE_ENDDATE_GUIDE_ID,
  UNIT_LIST_ADDRESS_GUIDE_ID,
  UNIT_LIST_EXTRA_INFO_GUIDE_ID,
  UNIT_LIST_NOTEICON_GUIDE_ID,
  UNIT_LIST_SUBLEASE_TAG_GUIDE_ID,
  UNIT_NOTES_ADD_GUIDE_ID,
  EMAIL_ATTACHMENTS_GUIDE_ID,
  EMAIL_LABELS_GUIDE_ID,
  EMAIL_OPTIONS_GUIDE_ID,
  EMAIL_PROCESSEDTAGS_GUIDE_ID,
  MARK_EMAIL_GUIDE_ID,
  SMS_COMMON_GUIDE_ID,
  SMS_OPTIONS_GUIDE_ID,
  MARK_SMS_GUIDE_ID,
  MANAGE_NOTICE_GUIDE_ID,
  MANAGE_NOTICE_ALERTS_GUIDE_ID,
  INBOXSETTINGS_GUIDE_ID,
  CONTACTS_GUIDE_ID,
  NOTICE_LIST_GUIDE_ID,
  BOARDMEETING_LIST_ACTIONS,
  BOARDMEETING_LIST_GENERAL,
  BOARDMEETING_SEARCH,
  BOARDMEETING_TABS,
  BOARDMEETING_CASELISTITEM,
  BOARDMEETING_CASELIST_GENERAL,
  BOARDMEETING_CREATE,
  BOARDMEETING_DETAILS_COMMON,
  BOARDMEETING_DETAILS_AGENDA,
  BOARDMEETING_DETAILS_COMPLETE,
  BOARDMEETING_DETAILS_NEWMEETING,
  BOARDMEETING_DETAILS_OPEN_CASE,
  BOARDMEETING_COMPLETE_SHARE_PROTOCOL,
  BOARDMEETING_DETAILS_COMPLETED,
  MESSAGES_ACTIONS_GUIDE_ID,
  MESSAGES_COMMON_GUIDE_ID,
} from '../constants/guides'

export const guideIsCompleted = (completedGuides: IGuide[], id: string) => {
  /**
   * Used to determined whether a single guide is completed
   */

  return completedGuides.findIndex((x) => x.tutorialId === id) !== -1
}

export const guidesAreCompleted = (
  completedGuides: IGuide[],
  ids: string[]
): boolean => {
  /**
   * Used to determined whether a set of guides are completed
   */

  let found = false
  ids.forEach((id) => {
    if (completedGuides.findIndex((x) => x.tutorialId === id) === -1) {
      found = true
      return
    }
  })

  return !found
}

export const isAllGuidesSkipped = (completedGuides: IGuide[]) => {
  return (
    completedGuides.findIndex((x) => x.tutorialId === SKIP_ALL_GUIDES) !== -1
  )
}

export const getGuideIds = (guide: GuideTypeEnum) => {
  switch (guide) {
    case GuideTypeEnum.boardAndCommittees:
      return [BOARD_AND_COMMITTES_GUIDE_ID]
    case GuideTypeEnum.insurance:
      return [INSURANCE_LIST_GUIDE_ID]
    case GuideTypeEnum.invoiceList:
      return [
        INVOICE_LIST_GUIDE_ID,
        INVOICE_ARCHIVE_GUIDE_ID,
        INVOICE_LIST_APPROVE_GUIDE_ID,
      ]
    case GuideTypeEnum.invoiceDetails:
      return [
        INVOICE_SUPPLIER_INFO_GUIDE_ID,
        INVOICE_PREVIOUS_GUIDE_ID,
        INVOICE_ALL_INFO_GUIDE_ID,
        INVOICE_VIEW_ATTACHMENT_GUIDE_ID,
      ]
    case GuideTypeEnum.subleaseList:
      return [SUBLEASE_LIST_GUIDE_ID]
    case GuideTypeEnum.subleaseDetails:
      return [SUBLEASE_OVERRIDE_ENDDATE_GUIDE_ID, SUBLEASE_HISTORY_GUIDE_ID]
    case GuideTypeEnum.unitsList:
      return [
        UNIT_LIST_ADDRESS_GUIDE_ID,
        UNIT_LIST_EXTRA_INFO_GUIDE_ID,
        UNIT_LIST_NOTEICON_GUIDE_ID,
        UNIT_LIST_SUBLEASE_TAG_GUIDE_ID,
      ]
    case GuideTypeEnum.unitDetails:
      return [UNIT_NOTES_ADD_GUIDE_ID]
    case GuideTypeEnum.sms:
      return [SMS_COMMON_GUIDE_ID, SMS_OPTIONS_GUIDE_ID, MARK_SMS_GUIDE_ID]
    case GuideTypeEnum.email:
      return [
        EMAIL_COMMON_GUIDE_ID,
        EMAIL_ATTACHMENTS_GUIDE_ID,
        EMAIL_LABELS_GUIDE_ID,
        EMAIL_OPTIONS_GUIDE_ID,
        EMAIL_PROCESSEDTAGS_GUIDE_ID,
        MARK_EMAIL_GUIDE_ID,
      ]
    case GuideTypeEnum.managenotice:
      return [MANAGE_NOTICE_GUIDE_ID, MANAGE_NOTICE_ALERTS_GUIDE_ID]
    case GuideTypeEnum.inboxSettings:
      return [INBOXSETTINGS_GUIDE_ID]
    case GuideTypeEnum.contacts:
      return [CONTACTS_GUIDE_ID]
    case GuideTypeEnum.noticelist:
      return [NOTICE_LIST_GUIDE_ID]
    case GuideTypeEnum.boardMeetingList:
      return [
        BOARDMEETING_TABS,
        BOARDMEETING_SEARCH,
        BOARDMEETING_LIST_GENERAL,
        BOARDMEETING_LIST_ACTIONS,
      ]
    case GuideTypeEnum.boardMeetingCaseList:
      return [
        BOARDMEETING_TABS,
        BOARDMEETING_SEARCH,
        BOARDMEETING_CASELIST_GENERAL,
        BOARDMEETING_CASELISTITEM,
      ]
    case GuideTypeEnum.createMeeting:
      return [BOARDMEETING_CREATE]
    case GuideTypeEnum.meetingDetails:
      return [
        BOARDMEETING_DETAILS_COMMON,
        BOARDMEETING_DETAILS_AGENDA,
        BOARDMEETING_DETAILS_OPEN_CASE,
        BOARDMEETING_DETAILS_NEWMEETING,
        BOARDMEETING_DETAILS_COMPLETE,
        BOARDMEETING_DETAILS_COMPLETED,
      ]
    case GuideTypeEnum.completeMeeting:
      return [BOARDMEETING_COMPLETE_SHARE_PROTOCOL]
    case GuideTypeEnum.messages:
      return [MESSAGES_COMMON_GUIDE_ID, MESSAGES_ACTIONS_GUIDE_ID]
    default:
      return []
  }
}

// Returns true if a certain guide is either completed or skipped
export const isGuideFinishedAction = (e: CallBackProps) =>
  e.action === 'close' || e.action === 'reset'

export const getUniqueIdsFromSteps = (steps: any) => {
  const ids: string[] = []

   
  steps.map((step: any) => {
    if (!ids.includes(step.id)) ids.push(step.id)
  })

  return ids
}
